export const CONFIG = {
  brand: process.env.REACT_APP_BRAND || 'hive',
  name: process.env.REACT_APP_BRAND_NAME || 'Hive OS',
  apiUrl: process.env.REACT_APP_API_URL || 'https://den.hiveos.farm/api/admin',
  productUrl: process.env.REACT_APP_PRODUCT_URL || 'https://the.hiveos.farm',
  fiatCurrency: process.env.REACT_APP_FIAT_CURRENCY || 'USD',
};
